import { mutatorAction } from 'satcheljs';
import getWeatherOptions from '../store/store';
import MailboxCalendarConfiguration from 'owa-service/lib/contract/MailboxCalendarConfiguration';
import { getCalendarConfiguration } from 'owa-calendar-configuration';
import WeatherError from '../store/schema/WeatherError';
import WeatherLocationType from 'owa-service/lib/contract/WeatherLocationType';

export const setWeatherList = mutatorAction(
    'setWeatherList',
    (newWeatherList: WeatherLocationType[]) => {
        const store = getWeatherOptions();
        store.weatherLocations = newWeatherList;
    }
);

export const deleteFromWeatherList = mutatorAction(
    'deleteFromWeatherList',
    (indexToDelete: number) => {
        const store = getWeatherOptions();
        if (store.weatherLocations == null) {
            let calendarConfiguration: MailboxCalendarConfiguration = getCalendarConfiguration();
            store.weatherLocations = calendarConfiguration.WeatherLocations.slice();
        }
        store.weatherLocations.splice(indexToDelete, 1);
    }
);

export const setWeatherError = mutatorAction(
    'setWeatherError',
    (weatherError: WeatherError, locationName?: string) => {
        const store = getWeatherOptions();
        store.weatherErrorState = weatherError;
        store.weatherErrorLocationName = locationName;
    }
);
